/* Native Shopify cart and product enhancement. No demo API, accounts or saved commerce state. */
(() => {
  'use strict';
  if (window.YulFishCommerce) return;
  const config = window.YulFishShopify || {};
  const root = String(config.root || window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const pending = new WeakSet(), productRequests = new WeakMap();
  const strings = config.strings || {};
  const t = (key, parameters = {}) => {
    const value = key.split('.').reduce((current, part) => current?.[part], strings) ?? strings[key] ?? key;
    return String(value).replace(/\{\{?\s*(\w+)\s*\}?\}/g, (match, name) => parameters[name] ?? match);
  };
  function money(cents, currency = config.currency) {
    try { return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'es', {style:'currency', currency:currency || 'EUR'}).format(Number(cents) / 100); }
    catch { return String(Number(cents) / 100) + ' ' + (currency || ''); }
  }
  function safeUrl(value) {
    if (!value || typeof value !== 'string') return '';
    try { const url = new URL(value, location.href); return /^https?:$/.test(url.protocol) ? url.href : ''; }
    catch { return ''; }
  }
  function node(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = String(text);
    return element;
  }
  let popover = null, returnTarget = null;
  function closePopover(restoreFocus = false) {
    if (!popover || popover.hidden) return;
    const inside = popover.contains(document.activeElement);
    popover.hidden = true;
    if (restoreFocus && inside && returnTarget?.isConnected) returnTarget.focus({preventScroll:true});
  }
  function positionPopover() {
    if (!popover || popover.hidden) return;
    const anchor = document.querySelector('[data-yf-cart-link]');
    const bounds = anchor?.getBoundingClientRect();
    const viewportWidth = Math.min(window.visualViewport?.width || window.innerWidth, document.documentElement.clientWidth || window.innerWidth);
    const viewportHeight = Math.min(window.visualViewport?.height || window.innerHeight, document.documentElement.clientHeight || window.innerHeight);
    const width = Math.min(420, Math.max(0, viewportWidth - 32));
    popover.style.width = width + 'px';
    const top = bounds && bounds.bottom >= 0 && bounds.bottom < viewportHeight - 100 ? Math.max(16, bounds.bottom + 12) : 16;
    const left = bounds ? Math.min(Math.max(16, bounds.right - width), Math.max(16, viewportWidth - width - 16)) : Math.max(16, viewportWidth - width - 16);
    popover.style.left = left + 'px';
    popover.style.right = 'auto';
    popover.style.top = top + 'px';
    popover.style.maxHeight = Math.max(90, viewportHeight - top - 16) + 'px';
  }
  function showPopover(item, cart, submittedQuantity, trigger) {
    if (!popover) {
      popover = node('section'); popover.id = 'YulFishCartPopover'; popover.hidden = true;
      popover.setAttribute('aria-labelledby', 'YulFishCartPopoverTitle');
      document.body.append(popover);
    }
    returnTarget = trigger;
    const head = node('div', 'yf-shopify-popover-head');
    const heading = node('h2', '', t('cart.added')); heading.id = 'YulFishCartPopoverTitle';
    const close = node('button', 'yf-shopify-popover-close', '×'); close.type = 'button'; close.setAttribute('aria-label', t('general.close')); close.addEventListener('click', () => closePopover(true));
    head.append(heading, close);
    const product = node('div', 'yf-shopify-popover-product');
    const photo = node('div', 'yf-shopify-popover-photo');
    const imageUrl = safeUrl(item.featured_image?.url || item.image);
    if (imageUrl) { const image = node('img'); image.src = imageUrl; image.alt = ''; image.width = 100; image.height = 100; photo.append(image); }
    const details = node('div', 'yf-shopify-popover-details');
    const title = node('a', 'yf-shopify-popover-name', item.product_title || item.title || ''); title.href = safeUrl(item.url) || root + 'cart'; details.append(title);
    if (item.variant_title && item.variant_title !== 'Default Title') details.append(node('p', '', item.variant_title));
    if (item.selling_plan_allocation?.selling_plan?.name) details.append(node('p', '', item.selling_plan_allocation.selling_plan.name));
    details.append(node('p', '', t('cart.added_quantity', {count:submittedQuantity})));
    details.append(node('strong', '', money((item.final_price ?? item.price ?? 0) * submittedQuantity, cart?.currency)));
    product.append(photo, details);
    const contents = [head, product];
    if (cart && Number.isFinite(cart.total_price)) {
      const subtotal = node('div', 'yf-shopify-popover-subtotal'); subtotal.append(node('span', '', t('cart.subtotal')), node('strong', '', money(cart.total_price, cart.currency))); contents.push(subtotal);
    }
    const basket = node('a', 'yf-shopify-primary', cart ? t('cart.view_count', {count:cart.item_count}) : t('cart.view')); basket.href = root + 'cart';
    const checkout = node('a', 'yf-shopify-popover-checkout', t('cart.checkout')); checkout.href = root + 'checkout';
    contents.push(basket, checkout);
    popover.replaceChildren(...contents); popover.hidden = false; positionPopover(); fitTitles(popover);
  }
  function updateCounts(cart) {
    if (!cart || !Number.isInteger(cart.item_count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = String(cart.item_count); element.hidden = cart.item_count === 0; });
    document.querySelectorAll('[data-yf-cart-link]').forEach(element => element.setAttribute('aria-label', t('cart.count_label', {count:cart.item_count})));
    document.dispatchEvent(new CustomEvent('yulfish:cart-updated', {detail:{cart}}));
  }
  function updatePhoto(product, src, alt, zoom = src) {
    const image = product.querySelector('.yf-shopify-main-image');
    const safe = safeUrl(src);
    if (!image || !safe) return;
    image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = safe; image.alt = alt || '';
    const link = product.querySelector('[data-yf-image-zoom]'); if (link) link.href = safeUrl(zoom) || safe;
    product.querySelectorAll('[data-yf-thumbnail]').forEach(thumbnail => {
      if (safeUrl(thumbnail.dataset.imageSrc) === safe) thumbnail.setAttribute('aria-current', 'true'); else thumbnail.removeAttribute('aria-current');
    });
  }
  function changeVariant(select) {
    const product = select.closest('[data-yf-product]'), form = select.closest('[data-yf-add-form]');
    const option = select.selectedOptions[0];
    if (!product || !form || !option) return;
    if (form.querySelector('[data-yf-selling-plan]')) {
      const url = new URL(product.dataset.productUrl, location.origin); url.searchParams.set('variant', option.value); loadProduct(product, url, select.id); return;
    }
    const available = option.dataset.available === 'true';
    const price = product.querySelector('[data-yf-price]'); if (price) price.textContent = money(option.dataset.price);
    const compare = product.querySelector('[data-yf-compare-price]');
    if (compare) { compare.hidden = !(Number(option.dataset.compare) > Number(option.dataset.price)); compare.textContent = money(option.dataset.compare); }
    const sku = product.querySelector('[data-yf-sku]'); if (sku) sku.textContent = option.dataset.sku || '';
    product.querySelectorAll('[data-yf-save-product]').forEach(control => { control.dataset.variantId = option.value; });
    const skuRow = product.querySelector('[data-yf-sku-row]'); if (skuRow) skuRow.hidden = !option.dataset.sku;
    const availability = product.querySelector('[data-yf-availability]'); if (availability) availability.textContent = t(available ? 'product.available' : 'product.sold_out');
    const button = form.querySelector('[data-yf-add-button]'); if (button) button.disabled = !available;
    const label = form.querySelector('[data-yf-add-label]'); if (label) label.textContent = t(available ? 'product.add_to_cart' : 'product.sold_out');
    const quantity = form.querySelector('[data-yf-quantity-input]');
    if (quantity) {
      quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.increment || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      if (!quantity.checkValidity()) quantity.value = quantity.min;
    }
    updatePhoto(product, option.dataset.image, option.dataset.imageAlt);
    const error = form.querySelector('[data-yf-form-error]'); if (error) { error.hidden = true; error.textContent = ''; }
    const url = new URL(location.href); url.searchParams.delete('option_values'); url.searchParams.set('variant', option.value); history.replaceState(history.state, '', url);
  }
  async function loadProduct(product, url, focusId) {
    if (pending.has(product.querySelector('[data-yf-add-form]'))) return;
    productRequests.get(product)?.abort();
    const controller = new AbortController(); productRequests.set(product, controller);
    product.setAttribute('aria-busy', 'true');
    const add = product.querySelector('[data-yf-add-button]'); if (add) add.disabled = true;
    const sectionUrl = new URL(url); sectionUrl.searchParams.set('section_id', product.dataset.sectionId);
    try {
      const response = await fetch(sectionUrl, {signal:controller.signal, credentials:'same-origin'});
      if (!response.ok) throw Error('Section unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = parsed.querySelector('[data-yf-product]'); if (!replacement) throw Error('Product unavailable');
      if (!product.isConnected) return;
      product.replaceWith(replacement); history.replaceState(history.state, '', url);
      fitTitles(replacement); initializeModels(replacement);
      if (focusId) replacement.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll:true});
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(url.href);
    } finally { if (productRequests.get(product) === controller) { product.removeAttribute('aria-busy'); productRequests.delete(product); } }
  }
  function optionValues(form) {
    const values = [...form.querySelectorAll('[data-yf-option-value]')].map(select => select.value);
    const hidden = form.querySelector('[data-yf-option-values]'); if (hidden) hidden.value = values.join(',');
    return values;
  }
  function showError(form, text, uncertain = false) {
    const error = form.querySelector('[data-yf-form-error]'); if (!error) return;
    error.textContent = text; error.hidden = false;
    if (uncertain) { error.append(document.createTextNode(' ')); const link = node('a', '', t('cart.view')); link.href = root + 'cart'; error.append(link); }
    error.tabIndex = -1; error.focus({preventScroll:true});
  }
  async function addToCart(form, trigger) {
    if (pending.has(form) || !form.reportValidity()) return;
    const data = new FormData(form), quantity = Number(data.get('quantity') || 1);
    const button = form.querySelector('[data-yf-add-button]');
    const error = form.querySelector('[data-yf-form-error]'); if (error) { error.hidden = true; error.textContent = ''; }
    const product = form.closest('[data-yf-product]');
    const controls = [...(product || form).querySelectorAll('input,select,button')].map(control => [control, control.disabled]);
    pending.add(form); form.setAttribute('aria-busy', 'true'); controls.forEach(([control]) => { control.disabled = true; });
    const status = form.querySelector('[data-yf-purchase-status]'); if (status) status.textContent = t('cart.adding');
    let confirmed = false;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', body:data, headers:{'Accept':'application/json'}, credentials:'same-origin'});
      let added;
      try { added = await response.json(); } catch { throw Error(t('cart.add_uncertain')); }
      if (!response.ok) {
        // Stock validation can cap a line on Shopify. Refresh the cart even when the add is rejected.
        try { const result = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin', cache:'no-store'}); if (result.ok) updateCounts(await result.json()); } catch { /* Keep the native error and a direct basket link. */ }
        const failure = Error(typeof added.description === 'string' ? added.description : t('cart.add_error')); failure.confirmedFailure = true; throw failure;
      }
      confirmed = true;
      const item = Array.isArray(added.items) ? added.items[0] : added;
      let cart = null;
      try { const result = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}, credentials:'same-origin', cache:'no-store'}); if (result.ok) cart = await result.json(); } catch { /* Addition succeeded; never retry a POST because refreshing its receipt failed. */ }
      updateCounts(cart); showPopover(item, cart, quantity, trigger || button);
      if (status) status.textContent = t('cart.added');
    } catch (error) {
      if (status) status.textContent = '';
      showError(form, error.confirmedFailure ? error.message : t('cart.add_uncertain'), true);
    } finally {
      pending.delete(form); form.removeAttribute('aria-busy'); controls.forEach(([control, disabled]) => { control.disabled = disabled; });
      const variant = form.querySelector('[data-yf-variant-select]')?.selectedOptions[0];
      if (button) button.disabled = variant ? variant.dataset.available !== 'true' : false;
      if (confirmed) document.dispatchEvent(new CustomEvent('yulfish:product-added'));
    }
  }
  function fitTitles(scope = document) {
    scope.querySelectorAll('[data-yf-fit-title],.yf-shopify-card-title,.yf-shopify-cart-item-title,.yf-shopify-popover-name').forEach(title => {
      if (!title.dataset.yfTitleOriginal) {
        title.dataset.yfTitleOriginal = title.textContent.trim(); title.setAttribute('aria-label', title.dataset.yfTitleOriginal);
        title.replaceChildren(...title.dataset.yfTitleOriginal.split(/\s+/).flatMap((word, index) => { const span = node('span', 'yf-shopify-title-word', word); span.setAttribute('aria-hidden', 'true'); return index ? [document.createTextNode(' '), span] : [span]; }));
      }
      title.style.fontSize = ''; const base = parseFloat(getComputedStyle(title).fontSize), width = title.clientWidth;
      if (!width) return;
      const longest = Math.max(...[...title.children].map(word => word.getBoundingClientRect().width), 1);
      if (longest > width) title.style.fontSize = Math.max(10, Math.floor(base * width / longest * .98)) + 'px';
    });
  }
  function initializeModels(scope = document) {
    if (!scope.querySelector('model-viewer') || typeof window.Shopify?.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([{name:'model-viewer-ui', version:'1.0', onLoad(error) { if (!error && window.Shopify.ModelViewerUI) scope.querySelectorAll('model-viewer').forEach(model => { if (!model.dataset.yfModelReady) { new window.Shopify.ModelViewerUI(model); model.dataset.yfModelReady = 'true'; } }); }}]);
  }
  document.addEventListener('submit', event => {
    const addForm = event.target.closest('[data-yf-add-form]');
    if (addForm) { event.preventDefault(); addToCart(addForm, event.submitter); return; }
    const options = event.target.closest('[data-yf-options-form]');
    if (options) { event.preventDefault(); optionValues(options); const product = options.closest('[data-yf-product]'); const url = new URL(product.dataset.productUrl, location.origin); url.searchParams.set('option_values', options.querySelector('[data-yf-option-values]').value); loadProduct(product, url); }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-yf-variant-select]'); if (select) { changeVariant(select); return; }
    const option = event.target.closest('[data-yf-option-value]');
    if (option) {
      const form = option.closest('[data-yf-options-form]'), product = option.closest('[data-yf-product]');
      const url = new URL(option.selectedOptions[0]?.dataset.productUrl || product.dataset.productUrl, location.origin); url.searchParams.set('option_values', optionValues(form).join(',')); loadProduct(product, url, option.id); return;
    }
    const plan = event.target.closest('[data-yf-selling-plan]');
    if (plan) { const product = plan.closest('[data-yf-product]'); const url = new URL(location.href); if (plan.value) url.searchParams.set('selling_plan', plan.value); else url.searchParams.delete('selling_plan'); loadProduct(product, url, plan.id); }
  });
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('[data-yf-thumbnail]');
    if (thumbnail && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) { event.preventDefault(); updatePhoto(thumbnail.closest('[data-yf-product]'), thumbnail.dataset.imageSrc, thumbnail.dataset.imageAlt, thumbnail.href); return; }
    const quantityButton = event.target.closest('[data-yf-quantity]');
    if (quantityButton) { const form = quantityButton.closest('[data-yf-add-form]'); if (pending.has(form)) return; const input = form.querySelector('[data-yf-quantity-input]'); Number(quantityButton.dataset.yfQuantity) > 0 ? input.stepUp() : input.stepDown(); input.dispatchEvent(new Event('change', {bubbles:true})); return; }
    if (popover && !popover.hidden && !popover.contains(event.target) && !event.target.closest('[data-yf-cart-link]')) closePopover();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && popover && !popover.hidden) { event.preventDefault(); closePopover(true); } });
  window.addEventListener('pagehide', () => closePopover());
  window.addEventListener('scroll', positionPopover, {passive:true});
  let resizeFrame = 0;
  window.addEventListener('resize', () => { positionPopover(); if (!resizeFrame) resizeFrame = requestAnimationFrame(() => { resizeFrame = 0; fitTitles(); }); }, {passive:true});
  const initialize = () => { document.documentElement.classList.add('js'); fitTitles(); initializeModels(); document.fonts?.ready.then(() => fitTitles()); };
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  window.YulFishCommerce = Object.freeze({closePopover, money, fitTitles});
})();
